import { Map, Record } from "immutable";

type Locale = "en" | "fr" | "jo";

interface LocaleMessages {
    [key: string]: string;
}

type LocaleData = {
    [P in Locale]: LocaleMessages;
};

interface LocalisationInternalState {
    language: string;
    entities: LocalisationNormalisedEntities;
}

interface LocalisationState {
    localisation: LocalisationInternalState;
}

interface TranslatableMap {
    en: string; // English is required always
    [key: string]: string;
}

interface ICountry {
    code?: string;
    name?: string;
    printableName?: TranslatableMap;
    nameTranslations?: TranslatableMap;
}

interface IRegion {
    code?: string;
    name?: string;
    countryCode?: string;
    hydrated?: boolean;
    // Relationships
    country?: ICountry;
}

const CountryRecord = Record({
    code: undefined,
    name: undefined,
    printableName: undefined,
    nameTranslations: undefined,
});

const RegionRecord = Record({
    code: undefined,
    name: undefined,
    countryCode: undefined,
    hydrated: false,
    country: undefined,
});

class Country extends CountryRecord implements ICountry {
    public code: string;
    public name: string;
    public printableName: TranslatableMap;
    public nameTranslations: TranslatableMap;
}

class Region extends RegionRecord implements IRegion {
    public code: string;
    public name: string;
    public countryCode: string;
    public nameTranslations: TranslatableMap;
    public hydrated: boolean;
    // Relationships
    public country: Country;
}

interface LocalisationNormalisedEntities {
    countries?: Map<string, Country>;
    regions?: Map<string, Region>;
}

export {
    Locale,
    LocaleMessages,
    LocaleData,
    LocalisationInternalState,
    LocalisationState,
    TranslatableMap,
    ICountry,
    Country,
    IRegion,
    Region,
    LocalisationNormalisedEntities,
};
